var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoHallmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e0e2e2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6h11.59l1 1-1 1H7zm12 8v2H7.41l-1-1 1-1zm0-4a1 1 0 00.71-.29l2-2a1 1 0 000-1.41l-2-2A1 1 0 0019 4h-5V2h-2v2H6a1 1 0 00-1 1v4a1 1 0 001 1h6v2H7a1 1 0 00-.71.29l-2 2a1 1 0 000 1.41l2 2A1 1 0 007 18h5v4h2v-4h6a1 1 0 001-1v-4a1 1 0 00-1-1h-6v-2z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoHallmin);
export default __webpack_public_path__ + "static/media/expo-hall.min.f7288d4e133b683dc01231e70d815d87.svg";
export { ForwardRef as ReactComponent };